import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { CurrencyProvider } from "@/context/CurrencyContext";

import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Careers from "@/pages/Careers";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Downloads from "@/pages/Downloads";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Profile from "@/pages/Profile";
import Wishlist from "@/pages/Wishlist";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminNews from "@/pages/admin/AdminNews";
import AdminCareers from "@/pages/admin/AdminCareers";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminPurchases from "@/pages/admin/AdminPurchases";
import AdminSuppliers from "@/pages/admin/AdminSuppliers";
import AdminEmployees from "@/pages/admin/AdminEmployees";

function App() {
    return (
        <AuthProvider>
            <CurrencyProvider>
                <WishlistProvider>
                    <CartProvider>
                        <BrowserRouter>
                            <Routes>
                                <Route element={<PublicLayout />}>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/about" element={<About />} />
                                    <Route path="/services" element={<Services />} />
                                    <Route path="/products" element={<Products />} />
                                    <Route path="/products/:slug" element={<ProductDetail />} />
                                    <Route path="/cart" element={<Cart />} />
                                    <Route path="/wishlist" element={<Wishlist />} />
                                    <Route path="/checkout" element={<Checkout />} />
                                    <Route path="/payment/success" element={<PaymentSuccess />} />
                                    <Route path="/careers" element={<Careers />} />
                                    <Route path="/news" element={<News />} />
                                    <Route path="/news/:slug" element={<NewsDetail />} />
                                    <Route path="/downloads" element={<Downloads />} />
                                    <Route path="/gallery" element={<Gallery />} />
                                    <Route path="/contact" element={<Contact />} />
                                    <Route path="/login" element={<Login />} />
                                    <Route path="/register" element={<Register />} />
                                    <Route path="/profile" element={<Profile />} />
                                </Route>

                                <Route path="/admin" element={<AdminLayout />}>
                                    <Route index element={<AdminDashboard />} />
                                    <Route path="products" element={<AdminProducts />} />
                                    <Route path="orders" element={<AdminOrders />} />
                                    <Route path="news" element={<AdminNews />} />
                                    <Route path="careers" element={<AdminCareers />} />
                                    <Route path="gallery" element={<AdminGallery />} />
                                    <Route path="messages" element={<AdminMessages />} />
                                    <Route path="users" element={<AdminUsers />} />
                                    <Route path="leads" element={<AdminLeads />} />
                                    <Route path="purchases" element={<AdminPurchases />} />
                                    <Route path="suppliers" element={<AdminSuppliers />} />
                                    <Route path="employees" element={<AdminEmployees />} />
                                </Route>
                            </Routes>
                        </BrowserRouter>
                    </CartProvider>
                </WishlistProvider>
            </CurrencyProvider>
        </AuthProvider>
    );
}

export default App;
